import { Course } from '../types';

export type CourseFacet = 'subject' | 'level' | 'tags';

export const normalizeCourseMetadata = (value: string): string =>
  value.trim().toLowerCase();

export const parseCourseMetadataInput = (value: string): string[] => {
  const seen = new Set<string>();
  return value
    .split(',')
    .map(item => item.trim())
    .filter(item => {
      const key = normalizeCourseMetadata(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const getCourseFacetValues = (
  course: Course,
  facet: CourseFacet
): string[] => {
  if (facet === 'subject') return course.subjects || [];
  if (facet === 'level') return course.levels || [];
  return course.tags || [];
};

export const courseMatchesFacet = (
  course: Course,
  facet: CourseFacet,
  selected: string[]
): boolean => {
  if (selected.length === 0) return true;
  const courseValues = new Set(
    getCourseFacetValues(course, facet).map(normalizeCourseMetadata)
  );
  return selected.some(value => courseValues.has(normalizeCourseMetadata(value)));
};

export const courseMatchesSearch = (course: Course, query: string): boolean => {
  const normalizedQuery = normalizeCourseMetadata(query);
  if (!normalizedQuery) return true;
  return [
    course.title,
    course.description,
    course.detailed_description,
    ...course.subjects,
    ...course.levels,
    ...course.tags,
  ].some(value => value.toLowerCase().includes(normalizedQuery));
};
